import type { StorageObjectGroupListV2ApiData } from '@navio/nsdk';

import type { ApiInput } from '../../utils';

/**
 * Collapse plate filters into one comma-separated query param instead of many
 * repeated keys. Very long URLs from repeated params can trigger browser/proxy
 * issues (including CORS failures on preflight).
 */
export function storageObjectGroupsListQueryParamsForUrl(
  queryParams: ApiInput<StorageObjectGroupListV2ApiData>
): Record<string, unknown> {
  const { licensePlateNumbers, excludedLicensePlateNumbers, ...rest } = queryParams;
  return {
    ...rest,
    ...(licensePlateNumbers != null && licensePlateNumbers.length > 0
      ? { licensePlateNumbers: licensePlateNumbers.join(',') }
      : {}),
    ...(excludedLicensePlateNumbers != null && excludedLicensePlateNumbers.length > 0
      ? { excludedLicensePlateNumbers: excludedLicensePlateNumbers.join(',') }
      : {})
  };
}
